import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as ProjectActions from "../../data/projects/ProjectActions";

import CreateProjectDialog from './CreateProjectDialog';

const mapStateToProps = (state, ownProps) => ({
    accountId: state.currentAccountId
});

const mapDispatchToProps = {
    createProject: ProjectActions.createProject,
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(CreateProjectDialog)
);
